import supabase from "supabaseClient";

interface Prayer {
  prayerRequest: string;
  userRequest: string;
}

export class AxiosWidgetPrayer {
  constructor() {}

  async updatePrayer(userid: string) {
    const { data, error } = await (supabase as any)
      .from("ProfilePrayer")
      .update({
        status: true,
      })
      .eq("id", userid); // Corrected this line

    if (error) {
      console.error("Error creating prayer:", error);
      throw error;
    }

    return data;
  }

  async getPrayer(user: string) {
    const { data, error } = await (supabase as any)
      .from("ProfilePrayer")
      .select("*")
      .eq("receiver", user);

    if (error) {
      // It's generally better to throw an error or handle it more gracefully
      // instead of returning the error object directly.
      console.error("Error fetching prayer:", error);
      throw error;
    }

    return { data };
  }

  async createPrayer(
    prayerContent: string,
    userRequest: string,
    userProfile: string
  ) {
    const { data, error } = await (supabase as any)
      .from("ProfilePrayer")
      .insert({
        user: userRequest,
        prayer: prayerContent,
        receiver: userProfile,
      });

    if (error) {
      console.error("Error creating prayer:", error);
      throw error;
    }

    return data;
  }
}

export default new AxiosWidgetPrayer();
